import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface categoryType {
    edit: boolean;
    categoryId: string;
    categoryName: string;
    categoryIcon: string;
    categoryPosition: number;
    categoryDesc: string;
    questionList?: any[];
    assigneeCount?: number;
}
const initialState = {
    category: {
        edit: false,
        categoryId: '',
        categoryName: '',
        categoryIcon: '',
        categoryPosition: 0,
    },
    userInfo: {
        adminId: '',
        streamApiKey: '',
        chatAccessToken: '',
    },
    unReadCount: 0,
    chatUser: {
        chatUserId: '',
        chatuserIdentity: '',
        chatUserName: '',
    },
    voucherCodeId: '',
};

export const stateSlice = createSlice({
    name: 'state',
    initialState,
    reducers: {
        setUserInfo: (
            state,
            action: PayloadAction<{ adminId: string; streamApiKey: string; chatAccessToken: string }>
        ) => {
            state.userInfo = action.payload;
        },
        setCategoryState: (state, action: PayloadAction<categoryType>) => {
            state.category = action.payload;
        },
        setUnReadCount: (state, action: PayloadAction<number>) => {
            state.unReadCount = action.payload;
        },
        setChatUser: (
            state,
            action: PayloadAction<{ chatUserId: string; chatuserIdentity: string; chatUserName?: string }>
        ) => {
            state.chatUser = { ...action.payload, chatUserName: action.payload.chatUserName ?? '' };
        },
        setvoucherCodeId: (state, action: PayloadAction<string>) => {
            state.voucherCodeId = action.payload;
        },
        reset: () => initialState,
    },
});

export const { setCategoryState, setUnReadCount, setUserInfo, setChatUser, setvoucherCodeId, reset } =
    stateSlice.actions;

export default stateSlice.reducer;
